import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

import { transition } from "@ui/helpers";

export const ImageWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
`;

export const Image = styled(GatsbyImage)`
  height: 380px;

  transition: ${props =>
    transition("transform", props.theme.animations.durationLong, "ease-out")};

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    height: 400px;
  }
`;

export const AnchorOverlay = styled.a`
  position: absolute;
  z-index: 1;
  inset: 0;
  opacity: 0;
`;

export const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  user-select: none;
  gap: ${({ theme }) => theme.spacing.spacing_16};

  &:has(${AnchorOverlay}:hover) {
    ${({ theme }) => theme.breakpointsV2.smallTablet} {
      ${Image} {
        transform: scale(1.05);
      }
    }
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    gap: ${({ theme }) => theme.spacing.spacing_24};
  }
`;
